import React from 'react';
const { useState } = React;
import { ROLEPLAY_PROFILE_FIELDS, ROLEPLAY_TEXT_MAX, t } from '../../diagnosticConfig.js';
import { Field, inputSt, textareaSt, cardSt, labelSt, mutedSt } from './shared.jsx';

// Configuración: founder's goal, the account for the exercises and the fictional
// client of the role-play (Diagnostics › Roleplay Profile), as in guia-1a1.md.

export default function DiagnosticSetup({ diagnostic: d, busy, onUpdate }) {
  const initial = {
    founderGoal: d.founderGoal || '', exerciseAccountName: d.exerciseAccountName || '',
    exerciseAccountWebsite: d.exerciseAccountWebsite || '', exerciseAccountCountry: d.exerciseAccountCountry || '',
  };
  const [edit, setEdit] = useState(initial);
  const initialProfile = Object.fromEntries(ROLEPLAY_PROFILE_FIELDS.map(f => [f.key, d.roleplayProfile?.[f.key] || '']));
  const [profile, setProfile] = useState(initialProfile);
  const set = (k) => (e) => setEdit({ ...edit, [k]: e.target.value });
  const changed = Object.keys(edit).some(k => edit[k] !== initial[k]);
  const profileChanged = Object.keys(profile).some(k => profile[k] !== initialProfile[k]);

  return (
    <div>
      <div style={cardSt}>
        <div style={{ ...labelSt, marginBottom: 12 }}>Meta y cuenta de los ejercicios</div>
        <Field label="Meta del founder">
          <textarea style={textareaSt} value={edit.founderGoal} maxLength={5000} onChange={set('founderGoal')} />
        </Field>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginTop: 12 }}>
          <Field label="Empresa"><input style={inputSt} value={edit.exerciseAccountName} maxLength={200} onChange={set('exerciseAccountName')} /></Field>
          <Field label="Web"><input style={inputSt} value={edit.exerciseAccountWebsite} maxLength={500} onChange={set('exerciseAccountWebsite')} /></Field>
          <Field label="País"><input style={inputSt} value={edit.exerciseAccountCountry} maxLength={100} onChange={set('exerciseAccountCountry')} /></Field>
        </div>
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <button className="action-btn btn-primary" disabled={busy || !changed} onClick={() => onUpdate(edit)}>
            {busy ? '⏳' : '💾 Guardar'}
          </button>
        </div>
      </div>

      <div style={cardSt}>
        <div style={{ ...labelSt, marginBottom: 4 }}>Cliente ficticio del role-play</div>
        <div style={{ ...mutedSt, marginBottom: 12 }}>
          Sobre la cuenta del ejercicio{d.exerciseAccountName ? ` (${d.exerciseAccountName})` : ''}. Es la misma para todo el equipo, para poder comparar.
          Un dato se revela solo si la pregunta lo merece; la objeción va al final.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 12 }}>
          {ROLEPLAY_PROFILE_FIELDS.map(f => (
            <Field key={f.key} label={t(f.label)} hint={t(f.hint)}>
              <textarea style={{ ...textareaSt, minHeight: 50 }} value={profile[f.key]} maxLength={ROLEPLAY_TEXT_MAX}
                onChange={e => setProfile({ ...profile, [f.key]: e.target.value })} />
            </Field>
          ))}
        </div>
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <button className="action-btn btn-primary" disabled={busy || !profileChanged} onClick={() => onUpdate({ roleplayProfile: profile })}>
            {busy ? '⏳' : '💾 Guardar ficha'}
          </button>
        </div>
      </div>
    </div>
  );
}
